import { Locale } from '@ps-smart-cp/ppfw-client';

const paymentCycleConfig = {
  everyMonth: new Map([[Locale.ja, '毎月']]),
  everyTwoMonths: new Map([[Locale.ja, '2ヶ月毎']]),
  everyThreeMonths: new Map([[Locale.ja, '3ヶ月毎']]),
  everyFourMonths: new Map([[Locale.ja, '4ヶ月毎']]),
  semiannually: new Map([[Locale.ja, '半年毎']]),
  annually: new Map([[Locale.ja, '1年毎']]),
  unset: new Map([[Locale.ja, '未設定']]),
};

export { paymentCycleConfig };
